// components/FeeStructure.jsx
import React from "react";
import { FaMoneyBillWave, FaCheckCircle } from "react-icons/fa";

const FeeStructure = () => {
  return (
    <section className="relative py-20 px-4 md:px-10 bg-gradient-to-br from-orange-50 via-white to-red-50">
      
      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-orange-300/20 rounded-full blur-3xl -translate-x-24"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-red-300/20 rounded-full blur-3xl translate-x-24"></div>

      <div className="relative max-w-5xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-12">
          <span className="inline-block px-5 py-2 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-3">
            Fee Details
          </span>

          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
            Fee{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Structure
            </span>
          </h2>

          <p className="text-gray-600 mt-3 text-sm md:text-base">
            Transparent, simple and affordable fee structure for quality education.
          </p>
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-[28px] shadow-xl border border-orange-100 overflow-hidden">

          {/* Header Strip */}
          <div className="bg-gradient-to-r from-red-600 to-orange-500 text-white px-6 py-4 flex items-center gap-3">
            <FaMoneyBillWave className="text-lg" />
            <h3 className="text-lg font-bold">Fee Overview</h3>
          </div>

          <div className="p-6 md:p-8">

            {/* Fees */}
            <div className="space-y-4">

              <div className="flex justify-between items-center bg-orange-50 border border-orange-100 rounded-xl p-4">
                <span className="text-sm font-semibold text-gray-700">
                  Registration Fee (One Time)
                </span>
                <span className="text-red-600 font-bold text-lg">
                  ₹ 3200
                </span>
              </div>

              <div className="flex justify-between items-center bg-orange-50 border border-orange-100 rounded-xl p-4">
                <span className="text-sm font-semibold text-gray-700">
                  Caution Money (Refundable)
                </span>
                <span className="text-red-600 font-bold text-lg">
                  ₹ 1000
                </span>
              </div>

            </div>

            {/* Divider */}
            <div className="my-6 border-t border-gray-200"></div>

            {/* Notes */}
            <div className="space-y-3 text-sm text-gray-700">
              {[
                "Fees should be paid only to authorized school staff.",
                "Caution money will be refunded at the time of leaving the school.",
                "Fee once paid is non-refundable except caution deposit.",
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <FaCheckCircle className="text-green-500 mt-1" />
                  <p>{item}</p>
                </div>
              ))}
            </div>

          </div>
        </div>

        {/* Bottom Note */}
        <div className="mt-6 text-center">
          <p className="text-xs md:text-sm text-gray-500">
            For detailed class-wise fee structure, please contact the school office.
          </p>
        </div>

      </div>
    </section>
  );
};

export default FeeStructure;